import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Practice from '../../components/Practice';
import Logo from '../../images/logo.png'

const PracticePage =() => {
    return(
        <Fragment>
            <Navbar Logo={Logo}/>
            <PageTitle pageTitle={'Practice'} pagesub={'Practice'}/> 
            <Practice sClass={'service-section-s2'} tClass={'section-title-s2'}/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default PracticePage;

